export const AppConfig = {
    UACode: 'UA-98502519-9'
}